import React from 'react';
import { ButtonBase, makeStyles } from '@material-ui/core';

type Props = {
  imageBase64: string;
};

const useStyles = makeStyles({
  container: {
    width: '100%',
    height: 300,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden',
    borderRadius: 10,
  },
});

const ImagePreview = ({ imageBase64 }: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <ButtonBase
      data-testid="preview-image"
      className={classes.container}
      disableRipple
      style={{
        backgroundImage: `url(${imageBase64})`,
      }}
    />
  );
};

export default ImagePreview;
